export default __webpack_public_path__ + "b67c2bacd4044beb800615512fbe953b.svg";